import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// services/wallRewards.service.js
export const rewardList = (params = '') => Http.get(`/wall-rewards${serialize(params)}&include=users`)
export const rewardCreate = (params = '') => Http.post('/wall-rewards', params)
export const rewardByID = (params = '') => Http.get(`/wall-rewards/${params}?include=users       `)
export const rewardUpdate = (params = '') => Http.put(`/wall-rewards/${params.id}`, params)
export const rewardDestroy = (params = '') => Http.delete(`/wall-rewards/${params.id}`)

// User functions 
export const rewardUserCreate = (rewardId, userData) => Http.post(`/wall-rewards/${rewardId}/users`, userData)
export const rewardUserDestroy = (rewardId, userId) => Http.delete(`/wall-rewards/${rewardId}/users/${userId}`)

// Add Pixels
export const rewardPixelCreate = (rewardId, userData) => Http.post(`/wall-rewards/${rewardId}/pixels`, userData)
